<template>
  <router-link
    to='/dashboard'
    class="logo__img"
    data-test-id="logo-link"
  >
    <img
      src="/static/CryptoPort.webp"
      alt="CryptoPort"
      data-test-id="logo-img"
    />
  </router-link>
</template>

<script>
  export default { name: 'logotype' }
</script>

<style scoped lang="scss">
  .logo__img {
    display: flex;
    align-items: center;

    img {
      max-width: 196px;
      width: 100%;
      max-height: 48px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/vue/app/common/Logotype.vue